import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { DiscussionEmbed } from "disqus-react";

function PressDetails() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [livs, setLivs] = useState([]);
  const [contests, setContests] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("Web-token");
        const lang = localStorage.getItem("selectedLanguage");
        let response;

        if (token) {
          response = await axios.get("/app/dashboard/authenticated", {
            headers: {
              Authorization: `Bearer ${token}`,
              "Accept-Language": lang,
            },
          });
        } else {
          response = await axios.get("/app/dashboard/public", {
            headers: {
              "Accept-Language": lang,
            },
          });
        }

        if (response?.data?.data && isMounted) {
          setLivs(response.data.data.livelinks || []);
          setContests(response.data.data.contests || []);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const lang = localStorage.getItem("selectedLanguage");

        setIsLoading(true);
        const response = await axios.get(
          `app/press/get-press-by-id?press_id=${id}`,
          {
            headers: {
              "Accept-Language": lang,
            },
          }
        );
        setArticle(response.data.data);
      } catch (err) {
        setError("Failed to load article.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchArticle();
  }, [id]);

  if (isLoading) {
    return <div>Loading...</div>; // Loading message
  }

  if (error) {
    return <div>{error}</div>; // Error message
  }

  if (!article) {
    return <div>No article found.</div>; // Handle case where no article is found
  }

  const disqusShortname = "https-spotsball-com"; // Replace this with your actual shortname
  const disqusConfig = {
    url: window.location.href,
    identifier: article._id,
    title: article.title,
  };

  return (
    <>
      <Helmet>
        <title>{article.title}</title>
      </Helmet>
      <section className="maincont_section">
        <div className="container contforinner_mainheading">
          <div className="row rowmainheading_inner">
            <div className="col-lg-8 colmainheading_innerpages">
              <div className="pageheading_main">
                <h1 className="text-left">{article.title}</h1>
              </div>
              <div className="row rowpressemptymain">
                <div className="mb-1">
                  <div className="emptypresstext image-press">
                    <img
                      src={article.press_banner}
                      alt="Press Banner"
                      className="w-100 mb-3"
                    />
                  </div>
                </div>
                <div
                  dangerouslySetInnerHTML={{ __html: article.description }}
                />
              </div>
              <div className="mt-5">
                <h3>{t("Comments")}</h3>
                <DiscussionEmbed
                  shortname={disqusShortname}
                  config={disqusConfig}
                />
              </div>
            </div>
            <div className="col-lg-4 colmainheading_innerpages">
              <div className="pageheading_main">
                <h1 className="text-left">Current Contest</h1>
              </div>
              <div className="row rowpressemptymain">
                <div className="mb-1">
                  <div className="emptypresstext image-press">
                    {contests?.length > 0 &&
                      contests[0]?.contest_banner?.file_url && (
                        <img
                          className="w-100"
                          src={contests[0].contest_banner.file_url}
                          alt="Contest Banner"
                        />
                      )}
                  </div>
                </div>
                <div className="compitiontextinfodivmain press_page">
                  <div className="contestpoints_main">
                    <div className="contesteveryweekdiv">
                      <div className="contest_newtiming_strip">
                        <span className="line-img">
                          <img src="/images/calendar.png" />
                        </span>
                        <h4>Every Week’s Contest Ends</h4>
                      </div>
                      <div className="contestrightdaysdate contest_newtiming_strip mb-0">
                        <span className="line-img calendar">
                          <img src="/images/wall-clock.png" />
                        </span>
                        <h4 className="contslist_span_inner">
                          Sunday- 23:59hrs
                        </h4>
                      </div>
                    </div>
                    <div className="contesteveryweekdiv">
                      <div className="contest_newtiming_strip">
                        <span className="line-img ">
                          <img src="/images/calendar.png" />
                        </span>
                        <h4>
                          Every Week Live Stream <br /> SpotsBall’s “Weekly
                          Winner Show”
                        </h4>
                      </div>
                      <div className="contestrightdaysdate contest_newtiming_strip mb-0">
                        <span className="line-img calendar">
                          <img src="/images/wall-clock.png" />
                        </span>
                        <h4 className="contslist_span_inner">
                          Monday- 21:00hrs
                        </h4>
                      </div>
                    </div>
                    <div
                      className="everyweek_livewatchdiv contesteveryweekdiv mb-0"
                      style={{ background: "none", boxShadow: "none" }}
                    >
                      <div className="watchondiv">
                        {livs?.Facebook_Streaming && (
                          <a
                            href={livs.Facebook_Streaming}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span className="fb">
                              <i className="fa-brands fa-facebook"></i>{" "}
                              {t("Watch on Facebook")}
                            </span>
                          </a>
                        )}
                        {livs?.Youtube_Streaming && (
                          <a
                            href={livs.Youtube_Streaming}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span className="yt">
                              <i className="fa-brands fa-youtube"></i>{" "}
                              {t("Watch on YouTube")}
                            </span>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <section
                  className="tickets-section  py-80"
                  style={{
                    backgroundImage: 'url("./images/home-4-banner-bg.jpg")',
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <div className="container">
                    <div className="heading mb-3">
                      <div className="d-flex flex-wrap gap-16 align-items-center justify-content-between section-title">
                        <h2 className="title">
                          Tickets <span>Available</span>
                        </h2>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-lg-12">
                        <div className="ticketing-slider blog_section">
                          <div className="ticket-container">
                            <div className="barcode-box">
                              <img
                                src="/images/barcode-2.png"
                                alt=""
                                className=" d-block"
                              />
                            </div>
                            <div className="ticket-line">
                              <img
                                src="/images/ticket-line-2.png"
                                alt=""
                                className=" d-block"
                              />
                            </div>
                            <div className="contest_maindiv_popup_inner">
                              <div className="contestheading">
                                <h2>
                                  <span>For</span> ₹50,000{" "}
                                  <span>Grand Prize</span>
                                </h2>
                              </div>
                              <div className="contesttickeprice">
                                <p>
                                  {" "}
                                  Ticket :
                                  <span>
                                    <i
                                      className="fa fa-inr"
                                      aria-hidden="true"
                                    />
                                    49/-
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="contest_quantity_para_div">
                                <div className="addcart_contst_textinfo">
                                  <img src="/images/ball_icon.png" />
                                  <h2>
                                    Use Add and subtract button for increase and
                                    decrease your tickets
                                  </h2>
                                </div>
                                <div className="addcart_contst_textinfo">
                                  <img src="/images/ball_icon.png" />
                                  <h2>Max 75 tickets per person</h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="container pressempty_cont">
          <div className="col-md-12 col12pressemptyscreen">
            <div className="row rowpressemptymain">
              <div className="mb-1">
                <div className="emptypresstext image-press">
                  <img
                    src={article.press_banner}
                    alt="Press Banner"
                    className="w-100 mb-3"
                  />
                </div>
              </div>
              <div dangerouslySetInnerHTML={{ __html: article.description }} />
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
}

export default PressDetails;
